export const contactsData = {
    email: 'mohamedalkasaby1@gmail.com',
    phone: '+491781897727',
    address: 'Schönbergstraße, 80507 Ingolstadt, Deutschland ',
    sheetAPI: 'https://sheetdb.io/api/v1/vauvypypw6p4t'
}